import React, { useEffect, useState, useRef, lazy } from 'react';
export function PricingSection() {
  const [bumps, setBumps] = useState({
    accoglienza: false,
    magicColor: false,
    agenda2030: false
  });
  const [flashKey, setFlashKey] = useState<string | null>(null);
  const flashTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Flash effect: briefly highlight the bump that was just toggled
  const handleBumpChange = (key: keyof typeof bumps, checked: boolean) => {
    setBumps(prev => ({
      ...prev,
      [key]: checked
    }));
    if (checked) {
      setFlashKey(key);
      if (flashTimeout.current) clearTimeout(flashTimeout.current);
      flashTimeout.current = setTimeout(() => setFlashKey(null), 600);
    }
  };
  useEffect(() => {
    return () => {
      if (flashTimeout.current) clearTimeout(flashTimeout.current);
    };
  }, []);
  // Checkout URL lookup based on selected bumps
  const getCheckoutUrl = () => {
    const key = `${bumps.accoglienza ? '1' : '0'}${bumps.magicColor ? '1' : '0'}${bumps.agenda2030 ? '1' : '0'}`;
    const urls: Record<string, string> = {
      '000': 'https://italia.edulabs.online/cart/43330386231414:1',
      '100': 'https://italia.edulabs.online/cart/43345489297526:1',
      '010': 'https://italia.edulabs.online/cart/43345507287158:1',
      '001': 'https://italia.edulabs.online/cart/43345509253238:1',
      '110': 'https://italia.edulabs.online/cart/43345602871414:1',
      '101': 'https://italia.edulabs.online/cart/43345614766198:1',
      '111': 'https://italia.edulabs.online/cart/43345619943542:1',
      '011': 'https://italia.edulabs.online/cart/43345616076918:1' // + Bump 2 + Bump 3
    };
    return urls[key] || urls['000'];
  };
  const checkoutUrl = getCheckoutUrl();
  // Dynamic pricing
  const bumpCount = [bumps.accoglienza, bumps.magicColor, bumps.agenda2030].filter(Boolean).length;
  const totalPrice = 19.9 + bumpCount * 9;
  const totalPriceFormatted = totalPrice.toFixed(2).replace('.', ',');
  const firePixel = () => {
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'AddToCart', {
        content_name: 'Arte Pronta Bundle' + (bumpCount > 0 ? ` + ${bumpCount} Bump` : ''),
        content_type: 'product',
        value: totalPrice,
        currency: 'EUR'
      });
    }
  };
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-163">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(234,88,12,0.08) 0%, transparent 70%)'
    }} data-id="element-164"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)'
    }} data-id="element-165"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-166">
        <h2 className="text-3xl sm:text-6xl font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-167">
          L'Offerta "Arte Pronta"
        </h2>

        {/* Featured Card */}
        <div className="bg-bg-alt rounded-xl sm:rounded-3xl border border-primary/50 shadow-[0_0_50px_rgba(59,130,246,0.15)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-168">
          {/* Glowing Border Effect */}
          <div className="absolute inset-0 rounded-xl sm:rounded-3xl border-2 border-transparent bg-gradient-to-b from-primary/50 to-transparent opacity-50 pointer-events-none" style={{
          maskImage: 'linear-gradient(to bottom, black, transparent)',
          WebkitMaskImage: 'linear-gradient(to bottom, black, transparent)'
        }} data-id="element-169"></div>

          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-gradient-to-r from-secondary to-yellow-400 text-bg-dark font-black text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_0_20px_rgba(245,158,11,0.5)] border border-white/20" data-id="element-170">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <p className="text-sm sm:text-3xl font-black text-text-main text-center mt-2 sm:mt-4 mb-3 sm:mb-10 tracking-wide" data-id="element-171">
            VALORE TOTALE DEI CONTENUTI:
          </p>

          {/* Compact list on mobile — dynamic items */}
          <div className="space-y-2 sm:space-y-5 mb-4 sm:mb-10 text-sm sm:text-xl" data-id="element-172">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-173">
              <span data-id="element-174">Percorso Didattico (5 Tomi Classe 1ª-5ª)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-175">
                € 97
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-176">
              <span data-id="element-177">Registro dell'Esperto & Materiale LIM</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-178">
                € 57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-179">
              <span data-id="element-180">Manuali Tecnici di Disegno</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-181">
                € 47
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-1.5 sm:pb-3" data-id="element-182">
              <span data-id="element-183">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-184">
                € 49
              </span>
            </div>

            {/* Dynamic bump items */}
            {bumps.accoglienza && <div className="flex justify-between text-cta-green font-medium border-b border-cta-green/20 pb-1.5 sm:pb-3 animate-[fadeInUp_0.3s_ease-out]" data-id="element-185">
                <span data-id="element-186">✅ Kit Accoglienza</span>
                <span className="ml-2 flex-shrink-0 font-bold" data-id="element-187">+ € 9,00</span>
              </div>}
            {bumps.magicColor && <div className="flex justify-between text-cta-green font-medium border-b border-cta-green/20 pb-1.5 sm:pb-3 animate-[fadeInUp_0.3s_ease-out]" data-id="element-188">
                <span data-id="element-189">✅ Manuale "Magic Color"</span>
                <span className="ml-2 flex-shrink-0 font-bold" data-id="element-190">+ € 9,00</span>
              </div>}
            {bumps.agenda2030 && <div className="flex justify-between text-cta-green font-medium border-b border-cta-green/20 pb-1.5 sm:pb-3 animate-[fadeInUp_0.3s_ease-out]" data-id="element-191">
                <span data-id="element-192">✅ Arte & Sostenibilità</span>
                <span className="ml-2 flex-shrink-0 font-bold" data-id="element-193">+ € 9,00</span>
              </div>}

            <div className="flex justify-between text-text-main font-black pt-1 sm:pt-4 text-base sm:text-2xl" data-id="element-194">
              <span data-id="element-195">VALORE REALE:</span>
              <span className="text-badge-red line-through" data-id="element-196">
                € {250 + bumpCount * 19}
              </span>
            </div>
          </div>

          {/* Price reveal — DYNAMIC */}
          <div className="text-center mb-3 sm:mb-10 bg-gradient-to-b from-primary/5 to-transparent border border-white/10 py-6 sm:py-10 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-197">
            <div className="absolute top-0 left-0 w-full h-0.5 sm:h-1 bg-gradient-to-r from-transparent via-primary to-transparent" data-id="element-198"></div>

            {/* Original price + discount badge */}
            <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-4" data-id="element-199">
              <span className="text-text-sec line-through text-base sm:text-2xl font-medium" data-id="element-200">
                € {(250 + bumpCount * 19).toFixed(2).replace('.', ',')}
              </span>
              <span className="bg-cta-green/20 text-cta-green font-black text-[10px] sm:text-sm px-2 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-201">
                {Math.round(100 - totalPrice / (250 + bumpCount * 19) * 100)}%
                OFF
              </span>
            </div>

            {/* Big price */}
            <div className="text-primary font-black text-5xl sm:text-8xl tracking-tighter transition-all leading-none" data-id="element-202">
              € {totalPriceFormatted}
            </div>

            {bumpCount > 0 && <div className="text-cta-green text-xs sm:text-base font-bold mt-2 sm:mt-3 animate-[fadeIn_0.3s_ease-out]" data-id="element-203">
                🎉 Risparmi € {(bumpCount * 10).toFixed(2).replace('.', ',')}{' '}
                sui bonus aggiunti!
              </div>}

            <div className="text-text-sec text-xs sm:text-base font-medium mt-2 sm:mt-3 flex items-center justify-center gap-2" data-id="element-204">
              <span data-id="element-205">💳 Pagamento unico</span>
              <span data-id="element-206">•</span>
              <span data-id="element-207">⚡ Accesso immediato</span>
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-secondary font-bold text-[10px] sm:text-sm bg-secondary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-secondary/20 animate-pulse-composited mx-auto mb-3 sm:mb-6" data-id="element-208">
            ⏰ Prezzo speciale di lancio — salirà a breve
          </span>

          {/* CTA Button — Top */}
          <a href={checkoutUrl} onClick={firePixel} className="btn-primary-pulse block w-full text-center bg-cta-green text-gray-900 font-black text-[17px] sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_0_40px_rgba(16,185,129,0.4)] border border-white/20 mb-6 pt-[25px] pb-[25px]" data-id="element-209">
            <span className="hidden sm:inline" data-id="element-210">
              🚀 SÌ! VOGLIO IL KIT COMPLETO — € {totalPriceFormatted}
            </span>
            <span className="sm:hidden text-[18px]" data-id="element-211">
              🚀 VOGLIO IL KIT — € {totalPriceFormatted}
            </span>
          </a>

          {/* Order Bumps Section */}
          <div className="flex flex-col gap-3 sm:gap-4 mb-6 sm:mb-8 w-full" data-id="element-212">
            <p className="text-center text-text-sec text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-1" data-id="element-213">
              ⚡ Aggiungi al tuo ordine e risparmia:
            </p>

            {/* Bump 1: Kit Accoglienza */}
            <label className={`relative flex flex-col items-center p-4 sm:p-5 rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${bumps.accoglienza ? 'bg-orange-500/10 border-orange-500' : 'bg-bg-alt border-orange-500/40 hover:border-orange-500/70'} ${flashKey === 'accoglienza' ? 'animate-[bumpFlash_0.6s_ease-out]' : ''}`} data-id="element-214">
              <span className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] sm:text-xs font-black uppercase tracking-wider px-4 py-1 sm:py-1.5 rounded-full mb-3" data-id="element-215">
                ⭐ ALTAMENTE RACCOMANDATO
              </span>
              <div className="flex items-start gap-3 w-full" data-id="element-216">
                <div className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mt-1 rounded border-2 flex-shrink-0 transition-colors ${bumps.accoglienza ? 'bg-orange-500 border-orange-500' : 'bg-transparent border-orange-500/50'}`} data-id="element-217">
                  <input type="checkbox" className="opacity-0 absolute inset-0 cursor-pointer" checked={bumps.accoglienza} onChange={e => handleBumpChange('accoglienza', e.target.checked)} data-id="element-218" />
                  {bumps.accoglienza && <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-219">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-220" />
                    </svg>}
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/4bULZ8iWc2zepCmzLMCaRu/heylloyd-image-1777310964097.png" alt="Kit Accoglienza" className="w-[56px] h-[56px] sm:w-[72px] sm:h-[72px] rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-221" />
                <div className="min-w-0 flex-1" data-id="element-222">
                  <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-223">
                    Kit Accoglienza 🎒
                  </p>
                  <p className="text-orange-500 font-black text-sm sm:text-lg mt-0.5" data-id="element-224">
                    + € 9,00{' '}
                    <span className="text-text-sec font-normal text-xs line-through ml-1" data-id="element-225">
                      € 19,00
                    </span>
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-1" data-id="element-226">
                    30 pagine con 10 attività "Apri e Stampa" per decorare
                    l'aula e gestire il primo giorno senza stress.
                  </p>
                </div>
              </div>
            </label>

            {/* Bump 2: Magic Color */}
            <label className={`relative flex flex-col items-center p-4 sm:p-5 rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${bumps.magicColor ? 'bg-orange-500/10 border-orange-500' : 'bg-bg-alt border-orange-500/40 hover:border-orange-500/70'} ${flashKey === 'magicColor' ? 'animate-[bumpFlash_0.6s_ease-out]' : ''}`} data-id="element-227">
              <span className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] sm:text-xs font-black uppercase tracking-wider px-4 py-1 sm:py-1.5 rounded-full mb-3" data-id="element-228">
                ⭐ ALTAMENTE RACCOMANDATO
              </span>
              <div className="flex items-start gap-3 w-full" data-id="element-229">
                <div className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mt-1 rounded border-2 flex-shrink-0 transition-colors ${bumps.magicColor ? 'bg-orange-500 border-orange-500' : 'bg-transparent border-orange-500/50'}`} data-id="element-230">
                  <input type="checkbox" className="opacity-0 absolute inset-0 cursor-pointer" checked={bumps.magicColor} onChange={e => handleBumpChange('magicColor', e.target.checked)} data-id="element-231" />
                  {bumps.magicColor && <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-232">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-233" />
                    </svg>}
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/r68EvcBZh2YTdygAFUMv9a/heylloyd-image-1777311240464.png" alt="Magic Color" className="w-[56px] h-[56px] sm:w-[72px] sm:h-[72px] rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-234" />
                <div className="min-w-0 flex-1" data-id="element-235">
                  <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-236">
                    Manuale "Magic Color" 🎨
                  </p>
                  <p className="text-orange-500 font-black text-sm sm:text-lg mt-0.5" data-id="element-237">
                    + € 9,00{' '}
                    <span className="text-text-sec font-normal text-xs line-through ml-1" data-id="element-238">
                      € 19,00
                    </span>
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-1" data-id="element-239">
                    Trucchi di sfumatura, gradienti e miscele con pennarelli.
                    Trasforma disegni mediocri in opere da mostra.
                  </p>
                </div>
              </div>
            </label>

            {/* Bump 3: Agenda 2030 */}
            <label className={`relative flex flex-col items-center p-4 sm:p-5 rounded-2xl border-2 cursor-pointer transition-all overflow-hidden ${bumps.agenda2030 ? 'bg-orange-500/10 border-orange-500' : 'bg-bg-alt border-orange-500/40 hover:border-orange-500/70'} ${flashKey === 'agenda2030' ? 'animate-[bumpFlash_0.6s_ease-out]' : ''}`} data-id="element-240">
              <span className="inline-flex items-center gap-1.5 bg-orange-500 text-white text-[10px] sm:text-xs font-black uppercase tracking-wider px-4 py-1 sm:py-1.5 rounded-full mb-3" data-id="element-241">
                ⭐ ALTAMENTE RACCOMANDATO
              </span>
              <div className="flex items-start gap-3 w-full" data-id="element-242">
                <div className={`relative flex items-center justify-center w-5 h-5 sm:w-6 sm:h-6 mt-1 rounded border-2 flex-shrink-0 transition-colors ${bumps.agenda2030 ? 'bg-orange-500 border-orange-500' : 'bg-transparent border-orange-500/50'}`} data-id="element-243">
                  <input type="checkbox" className="opacity-0 absolute inset-0 cursor-pointer" checked={bumps.agenda2030} onChange={e => handleBumpChange('agenda2030', e.target.checked)} data-id="element-244" />
                  {bumps.agenda2030 && <svg className="w-3 h-3 sm:w-4 sm:h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4} data-id="element-245">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-246" />
                    </svg>}
                </div>
                <img src="https://cdn.magicpatterns.com/uploads/vLxodoU4wJjRmesLG8jt4K/heylloyd-image-1777311472355.png" alt="Arte & Sostenibilità — Agenda 2030" className="w-[56px] h-[56px] sm:w-[72px] sm:h-[72px] rounded-xl object-cover flex-shrink-0" loading="lazy" data-id="element-247" />
                <div className="min-w-0 flex-1" data-id="element-248">
                  <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-249">
                    Arte & Sostenibilità 🌍
                  </p>
                  <p className="text-orange-500 font-black text-sm sm:text-lg mt-0.5" data-id="element-250">
                    + € 9,00{' '}
                    <span className="text-text-sec font-normal text-xs line-through ml-1" data-id="element-251">
                      € 19,00
                    </span>
                  </p>
                  <p className="text-text-sec text-[11px] sm:text-xs leading-snug mt-1" data-id="element-252">
                    12 laboratori di Educazione Civica sul riciclo e Agenda
                    2030. Include griglia di valutazione ufficiale.
                  </p>
                </div>
              </div>
            </label>
          </div>

          {/* CTA Button — Bottom (duplicate for visibility) */}
          <a href={checkoutUrl} onClick={firePixel} className="btn-primary-pulse block w-full text-center bg-cta-green text-gray-900 font-black sm:text-2xl py-3.5 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-colors shadow-[0_0_40px_rgba(16,185,129,0.4)] border border-white/20 mb-6 pt-[25px] pb-[25px] text-[18px]" data-id="element-253">
            🚀 ACQUISTA ORA — € {totalPriceFormatted}
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium mb-2 sm:mb-8 flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-254">
            <span data-id="element-255">⚡ Accesso Immediato</span>
            <span data-id="element-256">•</span>
            <span data-id="element-257">💳 Un solo Pagamento</span>
            <span data-id="element-258">•</span>
            <span data-id="element-259">🛡️ Garanzia 7 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}